import { useContext } from 'react';

import { MessengerContext } from '@contexts/index';

export function useMessenger() {
  const context = useContext(MessengerContext);

  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (context === undefined) {
    throw new Error(`useMessenger must be used within a MessengerProvider`);
  }

  const { handleReset, state } = context;
  const loading = !state.isInitialized;

  return { state, loading, reset: handleReset };
}
